"use client";
import React from "react";
import useIsMobile from "../../common/utils/useIsMobile";
import NavigationItem from "./NavigationItem";
import MenuCallToActionButton from "../../common/components/MenuCallToActionButton";
import MobileBackButton from "../../common/components/MobileBackButton";
import useNavigationStack from "../../common/utils/useNavigationStack";
import { Link } from "../../../navigation";

const ServicesLayout = ({
  data,
  backToMainMenu,
}: {
  data?: any;
  backToMainMenu?: (item?: any) => void;
}) => {
  const isMobile = useIsMobile();
  const { back, handleNavigateTo, currentNavigation, callToAction } =
    useNavigationStack(data, backToMainMenu);

  const imageSize = isMobile
    ? { width: 32, height: 32 }
    : { width: 64, height: 64 };
  const normalizedCurrentRootUrl =
    currentNavigation?.url?.route || currentNavigation?.url;
  return (
    <div className="mkt-sub-nav full-width services">
      <div className="container container-narrow">
        <MobileBackButton onClick={back} />
        <h3 className="ps-1 hide-on-not-mobile color-secondary regular-sans mt-4 mt-lg-0">
          <Link href={normalizedCurrentRootUrl}>
            {currentNavigation?.title}
          </Link>
        </h3>
        <div className="ps-1 row">
          {currentNavigation?.children?.map((item, aindex) => (
            <div
              key={`${item.url}-${aindex}`}
              className="col-lg-3 navigation-list-column navigation-list-column--services"
            >
              <NavigationItem
                className="navigation-list-item nav-hover d-inline-flex d-lg-block align-items-center gap-3"
                link={item?.url}
                title={item.title}
                image={item.data?.image}
                imageSize={imageSize}
                isLink={(!item?.children?.length && isMobile) || !isMobile}
                onClick={
                  isMobile && item?.children?.length
                    ? () => handleNavigateTo(item)
                    : null
                }
              />
              {item.children?.length > 0 && (
                <div
                  className={`row mt-2 ${isMobile && currentNavigation !== item.title ? "d-none" : ""}`}
                >
                  {item.children.map((child, bindex) => (
                    <div
                      key={`${child.url}-${aindex}-${bindex}`}
                      className={isMobile ? "ps-4" : "hide-on-mobile mb-3"}
                    >
                      <NavigationItem
                        link={child?.url}
                        title={child.title}
                        image={child.data?.image}
                        imageSize={{ width: 30, height: 5 }}
                        isLink={true}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <MenuCallToActionButton callToAction={callToAction} />
      </div>
    </div>
  );
};

export default ServicesLayout;
